import React from 'react';
import { connect } from 'react-redux';
import { updateHttpStatus as dispatchUpdateHttpStatus } from '../../actions/httpStatus';
import Error from './Error/Error';

const ERROR_HTTP_STATUS = 500;

type ErrorContainerProps = {
    shouldDispatchHttpStatus?: boolean;
    updateHttpStatus: () => void;
    pathname: string;
    isNetworkOnline?: boolean;
};

class NotFoundContainer extends React.Component<ErrorContainerProps> {
    constructor(props) {
        super(props);

        const { shouldDispatchHttpStatus, updateHttpStatus } = this.props;

        // this will for now only be used by Contento views
        if (shouldDispatchHttpStatus) {
            updateHttpStatus();
        }
    }

    render() {
        const { pathname, isNetworkOnline } = this.props;

        return <Error pathname={pathname} isNetworkOnline={isNetworkOnline} />;
    }
}

const mapDispatchToProps = (dispatch) => ({
    updateHttpStatus: () => dispatch(dispatchUpdateHttpStatus(ERROR_HTTP_STATUS)),
});

export default connect(null, mapDispatchToProps)(NotFoundContainer);
